module.exports = __webpack_public_path__ + "static/media/newProducts.2575ffe9.svg";